//© all rights reserved to 6over6 Ltd. 2022. This software (the "Software") is the property of 6over6 Ltd. and its licensors. Any use of the Software is strictly prohibited unless an explicit license or permission is granted by 6over6 Ltd.
export default {
  namespaced: true,
  state: {
    isFlowComplete: false,
    is_pd_oor: false,
    is_glasses_oor: false,
    prescription: {
      id: null,
      l_axis: null,
      l_cyl: null,
      l_sph: null,
      r_axis: null,
      r_cyl: null,
      r_sph: null,
      pd: null,
    },
  },
  mutations: {
    setPrescription(state, result) {
      Object.keys(state.prescription).forEach((key) => {
        state.prescription[key] = result[key];
      });
    },
  },
  actions: {
    setPrescription({ commit, rootState }, result) {
      const session = rootState.Session;
      result.id = `${session.userId}/${session.sessionId}`;
      commit("setPrescription", result);
    },
    setResults({ state, commit }, results) {
      for (let field in results) {
        if (field === "prescription") {
          commit("setPrescription", results["prescription"]);
          return;
        }
        state[field] = results[field];
      }
    },
  },
};
